/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as BantuanRouteImport } from './routes/bantuan'
import { Route as BumdesRouteImport } from './routes/bumdes'
import { Route as DemografiPekerjaanRouteImport } from './routes/demografi-pekerjaan'
import { Route as JennaAnalyticRouteImport } from './routes/jenna-analytic'
import { Route as KeamananRouteImport } from './routes/keamanan'
import { Route as KeuanganAnggaranRouteImport } from './routes/keuangan-anggaran'
import { Route as KinerjaDivisiRouteImport } from './routes/kinerja-divisi'
import { Route as PengaduanLayananPublikRouteImport } from './routes/pengaduan-layanan-publik'
import { Route as PengaturanRouteRouteImport } from './routes/pengaturan/route'
import { Route as ProfileRouteRouteImport } from './routes/profile/route'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SosialRouteImport } from './routes/sosial'
import { Route as WallRouteImport } from './routes/wall'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAiAssistantRouteRouteImport } from './routes/admin/ai-assistant/route'
import { Route as AdminApikeyRouteImport } from './routes/admin/apikey'
import { Route as AdminAuditLogRouteImport } from './routes/admin/audit-log'
import { Route as AdminHelpRouteImport } from './routes/admin/help'
import { Route as AdminPreferencesRouteImport } from './routes/admin/preferences'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminServerLogRouteImport } from './routes/admin/server-log'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminSystemHealthRouteImport } from './routes/admin/system-health'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as PengaturanAksesDanTimRouteImport } from './routes/pengaturan/akses-dan-tim'
import { Route as PengaturanKeamananRouteImport } from './routes/pengaturan/keamanan'
import { Route as PengaturanNotifikasiRouteImport } from './routes/pengaturan/notifikasi'
import { Route as PengaturanSinkronisasiRouteImport } from './routes/pengaturan/sinkronisasi'
import { Route as PengaturanUmumRouteImport } from './routes/pengaturan/umum'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ProfileEditRouteImport } from './routes/profile/edit'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as UsersIdRouteImport } from './routes/users/$id'
import { Route as AdminAiAssistantIndexRouteImport } from './routes/admin/ai-assistant/index'
import { Route as AdminAiAssistantLogRouteRouteImport } from './routes/admin/ai-assistant/log/route'
import { Route as AdminAiAssistantPemakaianRouteImport } from './routes/admin/ai-assistant/pemakaian'
import { Route as AdminAiAssistantPenyediaRouteImport } from './routes/admin/ai-assistant/penyedia'
import { Route as AdminAiAssistantPersonaRouteImport } from './routes/admin/ai-assistant/persona'
import { Route as AdminAiAssistantUmumRouteImport } from './routes/admin/ai-assistant/umum'
import { Route as AdminAiAssistantLogIndexRouteImport } from './routes/admin/ai-assistant/log/index'
import { Route as AdminAiAssistantLogUserIdIndexRouteImport } from './routes/admin/ai-assistant/log/$userId/index'
import { Route as AdminAiAssistantLogUserIdConversationIdRouteImport } from './routes/admin/ai-assistant/log/$userId/$conversationId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BantuanRoute = BantuanRouteImport.update({
  id: '/bantuan',
  path: '/bantuan',
  getParentRoute: () => rootRouteImport,
} as any)
const BumdesRoute = BumdesRouteImport.update({
  id: '/bumdes',
  path: '/bumdes',
  getParentRoute: () => rootRouteImport,
} as any)
const DemografiPekerjaanRoute = DemografiPekerjaanRouteImport.update({
  id: '/demografi-pekerjaan',
  path: '/demografi-pekerjaan',
  getParentRoute: () => rootRouteImport,
} as any)
const JennaAnalyticRoute = JennaAnalyticRouteImport.update({
  id: '/jenna-analytic',
  path: '/jenna-analytic',
  getParentRoute: () => rootRouteImport,
} as any)
const KeamananRoute = KeamananRouteImport.update({
  id: '/keamanan',
  path: '/keamanan',
  getParentRoute: () => rootRouteImport,
} as any)
const KeuanganAnggaranRoute = KeuanganAnggaranRouteImport.update({
  id: '/keuangan-anggaran',
  path: '/keuangan-anggaran',
  getParentRoute: () => rootRouteImport,
} as any)
const KinerjaDivisiRoute = KinerjaDivisiRouteImport.update({
  id: '/kinerja-divisi',
  path: '/kinerja-divisi',
  getParentRoute: () => rootRouteImport,
} as any)
const PengaduanLayananPublikRoute = PengaduanLayananPublikRouteImport.update({
  id: '/pengaduan-layanan-publik',
  path: '/pengaduan-layanan-publik',
  getParentRoute: () => rootRouteImport,
} as any)
const PengaturanRouteRoute = PengaturanRouteRouteImport.update({
  id: '/pengaturan',
  path: '/pengaturan',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRouteRoute = ProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SosialRoute = SosialRouteImport.update({
  id: '/sosial',
  path: '/sosial',
  getParentRoute: () => rootRouteImport,
} as any)
const WallRoute = WallRouteImport.update({
  id: '/wall',
  path: '/wall',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAiAssistantRouteRoute = AdminAiAssistantRouteRouteImport.update({
  id: '/ai-assistant',
  path: '/ai-assistant',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminApikeyRoute = AdminApikeyRouteImport.update({
  id: '/apikey',
  path: '/apikey',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminHelpRoute = AdminHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPreferencesRoute = AdminPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminServerLogRoute = AdminServerLogRouteImport.update({
  id: '/server-log',
  path: '/server-log',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSystemHealthRoute = AdminSystemHealthRouteImport.update({
  id: '/system-health',
  path: '/system-health',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const PengaturanAksesDanTimRoute = PengaturanAksesDanTimRouteImport.update({
  id: '/akses-dan-tim',
  path: '/akses-dan-tim',
  getParentRoute: () => PengaturanRouteRoute,
} as any)
const PengaturanKeamananRoute = PengaturanKeamananRouteImport.update({
  id: '/keamanan',
  path: '/keamanan',
  getParentRoute: () => PengaturanRouteRoute,
} as any)
const PengaturanNotifikasiRoute = PengaturanNotifikasiRouteImport.update({
  id: '/notifikasi',
  path: '/notifikasi',
  getParentRoute: () => PengaturanRouteRoute,
} as any)
const PengaturanSinkronisasiRoute = PengaturanSinkronisasiRouteImport.update({
  id: '/sinkronisasi',
  path: '/sinkronisasi',
  getParentRoute: () => PengaturanRouteRoute,
} as any)
const PengaturanUmumRoute = PengaturanUmumRouteImport.update({
  id: '/umum',
  path: '/umum',
  getParentRoute: () => PengaturanRouteRoute,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileRouteRoute,
} as any)
const ProfileEditRoute = ProfileEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => ProfileRouteRoute,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiAssistantIndexRoute = AdminAiAssistantIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAiAssistantRouteRoute,
} as any)
const AdminAiAssistantLogRouteRoute =
  AdminAiAssistantLogRouteRouteImport.update({
    id: '/log',
    path: '/log',
    getParentRoute: () => AdminAiAssistantRouteRoute,
  } as any)
const AdminAiAssistantPemakaianRoute =
  AdminAiAssistantPemakaianRouteImport.update({
    id: '/pemakaian',
    path: '/pemakaian',
    getParentRoute: () => AdminAiAssistantRouteRoute,
  } as any)
const AdminAiAssistantPenyediaRoute =
  AdminAiAssistantPenyediaRouteImport.update({
    id: '/penyedia',
    path: '/penyedia',
    getParentRoute: () => AdminAiAssistantRouteRoute,
  } as any)
const AdminAiAssistantPersonaRoute = AdminAiAssistantPersonaRouteImport.update({
  id: '/persona',
  path: '/persona',
  getParentRoute: () => AdminAiAssistantRouteRoute,
} as any)
const AdminAiAssistantUmumRoute = AdminAiAssistantUmumRouteImport.update({
  id: '/umum',
  path: '/umum',
  getParentRoute: () => AdminAiAssistantRouteRoute,
} as any)
const AdminAiAssistantLogIndexRoute =
  AdminAiAssistantLogIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminAiAssistantLogRouteRoute,
  } as any)
const AdminAiAssistantLogUserIdIndexRoute =
  AdminAiAssistantLogUserIdIndexRouteImport.update({
    id: '/$userId/',
    path: '/$userId/',
    getParentRoute: () => AdminAiAssistantLogRouteRoute,
  } as any)
const AdminAiAssistantLogUserIdConversationIdRoute =
  AdminAiAssistantLogUserIdConversationIdRouteImport.update({
    id: '/$userId/$conversationId',
    path: '/$userId/$conversationId',
    getParentRoute: () => AdminAiAssistantLogRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/pengaturan': typeof PengaturanRouteRouteWithChildren
  '/profile': typeof ProfileRouteRouteWithChildren
  '/bantuan': typeof BantuanRoute
  '/bumdes': typeof BumdesRoute
  '/demografi-pekerjaan': typeof DemografiPekerjaanRoute
  '/jenna-analytic': typeof JennaAnalyticRoute
  '/keamanan': typeof KeamananRoute
  '/keuangan-anggaran': typeof KeuanganAnggaranRoute
  '/kinerja-divisi': typeof KinerjaDivisiRoute
  '/pengaduan-layanan-publik': typeof PengaduanLayananPublikRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/sosial': typeof SosialRoute
  '/wall': typeof WallRoute
  '/admin/ai-assistant': typeof AdminAiAssistantRouteRouteWithChildren
  '/admin/apikey': typeof AdminApikeyRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/help': typeof AdminHelpRoute
  '/admin/preferences': typeof AdminPreferencesRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/server-log': typeof AdminServerLogRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/system-health': typeof AdminSystemHealthRoute
  '/admin/users': typeof AdminUsersRoute
  '/pengaturan/akses-dan-tim': typeof PengaturanAksesDanTimRoute
  '/pengaturan/keamanan': typeof PengaturanKeamananRoute
  '/pengaturan/notifikasi': typeof PengaturanNotifikasiRoute
  '/pengaturan/sinkronisasi': typeof PengaturanSinkronisasiRoute
  '/pengaturan/umum': typeof PengaturanUmumRoute
  '/profile/edit': typeof ProfileEditRoute
  '/users/$id': typeof UsersIdRoute
  '/admin/': typeof AdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/users/': typeof UsersIndexRoute
  '/admin/ai-assistant/log': typeof AdminAiAssistantLogRouteRouteWithChildren
  '/admin/ai-assistant/pemakaian': typeof AdminAiAssistantPemakaianRoute
  '/admin/ai-assistant/penyedia': typeof AdminAiAssistantPenyediaRoute
  '/admin/ai-assistant/persona': typeof AdminAiAssistantPersonaRoute
  '/admin/ai-assistant/umum': typeof AdminAiAssistantUmumRoute
  '/admin/ai-assistant/': typeof AdminAiAssistantIndexRoute
  '/admin/ai-assistant/log/': typeof AdminAiAssistantLogIndexRoute
  '/admin/ai-assistant/log/$userId/$conversationId': typeof AdminAiAssistantLogUserIdConversationIdRoute
  '/admin/ai-assistant/log/$userId/': typeof AdminAiAssistantLogUserIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/pengaturan': typeof PengaturanRouteRouteWithChildren
  '/bantuan': typeof BantuanRoute
  '/bumdes': typeof BumdesRoute
  '/demografi-pekerjaan': typeof DemografiPekerjaanRoute
  '/jenna-analytic': typeof JennaAnalyticRoute
  '/keamanan': typeof KeamananRoute
  '/keuangan-anggaran': typeof KeuanganAnggaranRoute
  '/kinerja-divisi': typeof KinerjaDivisiRoute
  '/pengaduan-layanan-publik': typeof PengaduanLayananPublikRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/sosial': typeof SosialRoute
  '/wall': typeof WallRoute
  '/admin/apikey': typeof AdminApikeyRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/help': typeof AdminHelpRoute
  '/admin/preferences': typeof AdminPreferencesRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/server-log': typeof AdminServerLogRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/system-health': typeof AdminSystemHealthRoute
  '/admin/users': typeof AdminUsersRoute
  '/pengaturan/akses-dan-tim': typeof PengaturanAksesDanTimRoute
  '/pengaturan/keamanan': typeof PengaturanKeamananRoute
  '/pengaturan/notifikasi': typeof PengaturanNotifikasiRoute
  '/pengaturan/sinkronisasi': typeof PengaturanSinkronisasiRoute
  '/pengaturan/umum': typeof PengaturanUmumRoute
  '/profile/edit': typeof ProfileEditRoute
  '/users/$id': typeof UsersIdRoute
  '/admin': typeof AdminIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/users': typeof UsersIndexRoute
  '/admin/ai-assistant/pemakaian': typeof AdminAiAssistantPemakaianRoute
  '/admin/ai-assistant/penyedia': typeof AdminAiAssistantPenyediaRoute
  '/admin/ai-assistant/persona': typeof AdminAiAssistantPersonaRoute
  '/admin/ai-assistant/umum': typeof AdminAiAssistantUmumRoute
  '/admin/ai-assistant': typeof AdminAiAssistantIndexRoute
  '/admin/ai-assistant/log': typeof AdminAiAssistantLogIndexRoute
  '/admin/ai-assistant/log/$userId/$conversationId': typeof AdminAiAssistantLogUserIdConversationIdRoute
  '/admin/ai-assistant/log/$userId': typeof AdminAiAssistantLogUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/pengaturan': typeof PengaturanRouteRouteWithChildren
  '/profile': typeof ProfileRouteRouteWithChildren
  '/bantuan': typeof BantuanRoute
  '/bumdes': typeof BumdesRoute
  '/demografi-pekerjaan': typeof DemografiPekerjaanRoute
  '/jenna-analytic': typeof JennaAnalyticRoute
  '/keamanan': typeof KeamananRoute
  '/keuangan-anggaran': typeof KeuanganAnggaranRoute
  '/kinerja-divisi': typeof KinerjaDivisiRoute
  '/pengaduan-layanan-publik': typeof PengaduanLayananPublikRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/sosial': typeof SosialRoute
  '/wall': typeof WallRoute
  '/admin/ai-assistant': typeof AdminAiAssistantRouteRouteWithChildren
  '/admin/apikey': typeof AdminApikeyRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/help': typeof AdminHelpRoute
  '/admin/preferences': typeof AdminPreferencesRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/server-log': typeof AdminServerLogRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/system-health': typeof AdminSystemHealthRoute
  '/admin/users': typeof AdminUsersRoute
  '/pengaturan/akses-dan-tim': typeof PengaturanAksesDanTimRoute
  '/pengaturan/keamanan': typeof PengaturanKeamananRoute
  '/pengaturan/notifikasi': typeof PengaturanNotifikasiRoute
  '/pengaturan/sinkronisasi': typeof PengaturanSinkronisasiRoute
  '/pengaturan/umum': typeof PengaturanUmumRoute
  '/profile/edit': typeof ProfileEditRoute
  '/users/$id': typeof UsersIdRoute
  '/admin/': typeof AdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/users/': typeof UsersIndexRoute
  '/admin/ai-assistant/log': typeof AdminAiAssistantLogRouteRouteWithChildren
  '/admin/ai-assistant/pemakaian': typeof AdminAiAssistantPemakaianRoute
  '/admin/ai-assistant/penyedia': typeof AdminAiAssistantPenyediaRoute
  '/admin/ai-assistant/persona': typeof AdminAiAssistantPersonaRoute
  '/admin/ai-assistant/umum': typeof AdminAiAssistantUmumRoute
  '/admin/ai-assistant/': typeof AdminAiAssistantIndexRoute
  '/admin/ai-assistant/log/': typeof AdminAiAssistantLogIndexRoute
  '/admin/ai-assistant/log/$userId/$conversationId': typeof AdminAiAssistantLogUserIdConversationIdRoute
  '/admin/ai-assistant/log/$userId/': typeof AdminAiAssistantLogUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/pengaturan'
    | '/profile'
    | '/bantuan'
    | '/bumdes'
    | '/demografi-pekerjaan'
    | '/jenna-analytic'
    | '/keamanan'
    | '/keuangan-anggaran'
    | '/kinerja-divisi'
    | '/pengaduan-layanan-publik'
    | '/signin'
    | '/signup'
    | '/sosial'
    | '/wall'
    | '/admin/ai-assistant'
    | '/admin/apikey'
    | '/admin/audit-log'
    | '/admin/help'
    | '/admin/preferences'
    | '/admin/roles'
    | '/admin/server-log'
    | '/admin/settings'
    | '/admin/system-health'
    | '/admin/users'
    | '/pengaturan/akses-dan-tim'
    | '/pengaturan/keamanan'
    | '/pengaturan/notifikasi'
    | '/pengaturan/sinkronisasi'
    | '/pengaturan/umum'
    | '/profile/edit'
    | '/users/$id'
    | '/admin/'
    | '/profile/'
    | '/users/'
    | '/admin/ai-assistant/log'
    | '/admin/ai-assistant/pemakaian'
    | '/admin/ai-assistant/penyedia'
    | '/admin/ai-assistant/persona'
    | '/admin/ai-assistant/umum'
    | '/admin/ai-assistant/'
    | '/admin/ai-assistant/log/'
    | '/admin/ai-assistant/log/$userId/$conversationId'
    | '/admin/ai-assistant/log/$userId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/pengaturan'
    | '/bantuan'
    | '/bumdes'
    | '/demografi-pekerjaan'
    | '/jenna-analytic'
    | '/keamanan'
    | '/keuangan-anggaran'
    | '/kinerja-divisi'
    | '/pengaduan-layanan-publik'
    | '/signin'
    | '/signup'
    | '/sosial'
    | '/wall'
    | '/admin/apikey'
    | '/admin/audit-log'
    | '/admin/help'
    | '/admin/preferences'
    | '/admin/roles'
    | '/admin/server-log'
    | '/admin/settings'
    | '/admin/system-health'
    | '/admin/users'
    | '/pengaturan/akses-dan-tim'
    | '/pengaturan/keamanan'
    | '/pengaturan/notifikasi'
    | '/pengaturan/sinkronisasi'
    | '/pengaturan/umum'
    | '/profile/edit'
    | '/users/$id'
    | '/admin'
    | '/profile'
    | '/users'
    | '/admin/ai-assistant/pemakaian'
    | '/admin/ai-assistant/penyedia'
    | '/admin/ai-assistant/persona'
    | '/admin/ai-assistant/umum'
    | '/admin/ai-assistant'
    | '/admin/ai-assistant/log'
    | '/admin/ai-assistant/log/$userId/$conversationId'
    | '/admin/ai-assistant/log/$userId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/pengaturan'
    | '/profile'
    | '/bantuan'
    | '/bumdes'
    | '/demografi-pekerjaan'
    | '/jenna-analytic'
    | '/keamanan'
    | '/keuangan-anggaran'
    | '/kinerja-divisi'
    | '/pengaduan-layanan-publik'
    | '/signin'
    | '/signup'
    | '/sosial'
    | '/wall'
    | '/admin/ai-assistant'
    | '/admin/apikey'
    | '/admin/audit-log'
    | '/admin/help'
    | '/admin/preferences'
    | '/admin/roles'
    | '/admin/server-log'
    | '/admin/settings'
    | '/admin/system-health'
    | '/admin/users'
    | '/pengaturan/akses-dan-tim'
    | '/pengaturan/keamanan'
    | '/pengaturan/notifikasi'
    | '/pengaturan/sinkronisasi'
    | '/pengaturan/umum'
    | '/profile/edit'
    | '/users/$id'
    | '/admin/'
    | '/profile/'
    | '/users/'
    | '/admin/ai-assistant/log'
    | '/admin/ai-assistant/pemakaian'
    | '/admin/ai-assistant/penyedia'
    | '/admin/ai-assistant/persona'
    | '/admin/ai-assistant/umum'
    | '/admin/ai-assistant/'
    | '/admin/ai-assistant/log/'
    | '/admin/ai-assistant/log/$userId/$conversationId'
    | '/admin/ai-assistant/log/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  PengaturanRouteRoute: typeof PengaturanRouteRouteWithChildren
  ProfileRouteRoute: typeof ProfileRouteRouteWithChildren
  BantuanRoute: typeof BantuanRoute
  BumdesRoute: typeof BumdesRoute
  DemografiPekerjaanRoute: typeof DemografiPekerjaanRoute
  JennaAnalyticRoute: typeof JennaAnalyticRoute
  KeamananRoute: typeof KeamananRoute
  KeuanganAnggaranRoute: typeof KeuanganAnggaranRoute
  KinerjaDivisiRoute: typeof KinerjaDivisiRoute
  PengaduanLayananPublikRoute: typeof PengaduanLayananPublikRoute
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
  SosialRoute: typeof SosialRoute
  WallRoute: typeof WallRoute
  UsersIdRoute: typeof UsersIdRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bantuan': {
      id: '/bantuan'
      path: '/bantuan'
      fullPath: '/bantuan'
      preLoaderRoute: typeof BantuanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bumdes': {
      id: '/bumdes'
      path: '/bumdes'
      fullPath: '/bumdes'
      preLoaderRoute: typeof BumdesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demografi-pekerjaan': {
      id: '/demografi-pekerjaan'
      path: '/demografi-pekerjaan'
      fullPath: '/demografi-pekerjaan'
      preLoaderRoute: typeof DemografiPekerjaanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jenna-analytic': {
      id: '/jenna-analytic'
      path: '/jenna-analytic'
      fullPath: '/jenna-analytic'
      preLoaderRoute: typeof JennaAnalyticRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keamanan': {
      id: '/keamanan'
      path: '/keamanan'
      fullPath: '/keamanan'
      preLoaderRoute: typeof KeamananRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keuangan-anggaran': {
      id: '/keuangan-anggaran'
      path: '/keuangan-anggaran'
      fullPath: '/keuangan-anggaran'
      preLoaderRoute: typeof KeuanganAnggaranRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kinerja-divisi': {
      id: '/kinerja-divisi'
      path: '/kinerja-divisi'
      fullPath: '/kinerja-divisi'
      preLoaderRoute: typeof KinerjaDivisiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pengaduan-layanan-publik': {
      id: '/pengaduan-layanan-publik'
      path: '/pengaduan-layanan-publik'
      fullPath: '/pengaduan-layanan-publik'
      preLoaderRoute: typeof PengaduanLayananPublikRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pengaturan': {
      id: '/pengaturan'
      path: '/pengaturan'
      fullPath: '/pengaturan'
      preLoaderRoute: typeof PengaturanRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sosial': {
      id: '/sosial'
      path: '/sosial'
      fullPath: '/sosial'
      preLoaderRoute: typeof SosialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wall': {
      id: '/wall'
      path: '/wall'
      fullPath: '/wall'
      preLoaderRoute: typeof WallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ai-assistant': {
      id: '/admin/ai-assistant'
      path: '/ai-assistant'
      fullPath: '/admin/ai-assistant'
      preLoaderRoute: typeof AdminAiAssistantRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/apikey': {
      id: '/admin/apikey'
      path: '/apikey'
      fullPath: '/admin/apikey'
      preLoaderRoute: typeof AdminApikeyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/help': {
      id: '/admin/help'
      path: '/help'
      fullPath: '/admin/help'
      preLoaderRoute: typeof AdminHelpRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/preferences': {
      id: '/admin/preferences'
      path: '/preferences'
      fullPath: '/admin/preferences'
      preLoaderRoute: typeof AdminPreferencesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/server-log': {
      id: '/admin/server-log'
      path: '/server-log'
      fullPath: '/admin/server-log'
      preLoaderRoute: typeof AdminServerLogRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/system-health': {
      id: '/admin/system-health'
      path: '/system-health'
      fullPath: '/admin/system-health'
      preLoaderRoute: typeof AdminSystemHealthRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/pengaturan/akses-dan-tim': {
      id: '/pengaturan/akses-dan-tim'
      path: '/akses-dan-tim'
      fullPath: '/pengaturan/akses-dan-tim'
      preLoaderRoute: typeof PengaturanAksesDanTimRouteImport
      parentRoute: typeof PengaturanRouteRoute
    }
    '/pengaturan/keamanan': {
      id: '/pengaturan/keamanan'
      path: '/keamanan'
      fullPath: '/pengaturan/keamanan'
      preLoaderRoute: typeof PengaturanKeamananRouteImport
      parentRoute: typeof PengaturanRouteRoute
    }
    '/pengaturan/notifikasi': {
      id: '/pengaturan/notifikasi'
      path: '/notifikasi'
      fullPath: '/pengaturan/notifikasi'
      preLoaderRoute: typeof PengaturanNotifikasiRouteImport
      parentRoute: typeof PengaturanRouteRoute
    }
    '/pengaturan/sinkronisasi': {
      id: '/pengaturan/sinkronisasi'
      path: '/sinkronisasi'
      fullPath: '/pengaturan/sinkronisasi'
      preLoaderRoute: typeof PengaturanSinkronisasiRouteImport
      parentRoute: typeof PengaturanRouteRoute
    }
    '/pengaturan/umum': {
      id: '/pengaturan/umum'
      path: '/umum'
      fullPath: '/pengaturan/umum'
      preLoaderRoute: typeof PengaturanUmumRouteImport
      parentRoute: typeof PengaturanRouteRoute
    }
    '/profile/': {
      id: '/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof ProfileRouteRoute
    }
    '/profile/edit': {
      id: '/profile/edit'
      path: '/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof ProfileEditRouteImport
      parentRoute: typeof ProfileRouteRoute
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ai-assistant/': {
      id: '/admin/ai-assistant/'
      path: '/'
      fullPath: '/admin/ai-assistant/'
      preLoaderRoute: typeof AdminAiAssistantIndexRouteImport
      parentRoute: typeof AdminAiAssistantRouteRoute
    }
    '/admin/ai-assistant/log': {
      id: '/admin/ai-assistant/log'
      path: '/log'
      fullPath: '/admin/ai-assistant/log'
      preLoaderRoute: typeof AdminAiAssistantLogRouteRouteImport
      parentRoute: typeof AdminAiAssistantRouteRoute
    }
    '/admin/ai-assistant/pemakaian': {
      id: '/admin/ai-assistant/pemakaian'
      path: '/pemakaian'
      fullPath: '/admin/ai-assistant/pemakaian'
      preLoaderRoute: typeof AdminAiAssistantPemakaianRouteImport
      parentRoute: typeof AdminAiAssistantRouteRoute
    }
    '/admin/ai-assistant/penyedia': {
      id: '/admin/ai-assistant/penyedia'
      path: '/penyedia'
      fullPath: '/admin/ai-assistant/penyedia'
      preLoaderRoute: typeof AdminAiAssistantPenyediaRouteImport
      parentRoute: typeof AdminAiAssistantRouteRoute
    }
    '/admin/ai-assistant/persona': {
      id: '/admin/ai-assistant/persona'
      path: '/persona'
      fullPath: '/admin/ai-assistant/persona'
      preLoaderRoute: typeof AdminAiAssistantPersonaRouteImport
      parentRoute: typeof AdminAiAssistantRouteRoute
    }
    '/admin/ai-assistant/umum': {
      id: '/admin/ai-assistant/umum'
      path: '/umum'
      fullPath: '/admin/ai-assistant/umum'
      preLoaderRoute: typeof AdminAiAssistantUmumRouteImport
      parentRoute: typeof AdminAiAssistantRouteRoute
    }
    '/admin/ai-assistant/log/': {
      id: '/admin/ai-assistant/log/'
      path: '/'
      fullPath: '/admin/ai-assistant/log/'
      preLoaderRoute: typeof AdminAiAssistantLogIndexRouteImport
      parentRoute: typeof AdminAiAssistantLogRouteRoute
    }
    '/admin/ai-assistant/log/$userId/': {
      id: '/admin/ai-assistant/log/$userId/'
      path: '/$userId'
      fullPath: '/admin/ai-assistant/log/$userId/'
      preLoaderRoute: typeof AdminAiAssistantLogUserIdIndexRouteImport
      parentRoute: typeof AdminAiAssistantLogRouteRoute
    }
    '/admin/ai-assistant/log/$userId/$conversationId': {
      id: '/admin/ai-assistant/log/$userId/$conversationId'
      path: '/$userId/$conversationId'
      fullPath: '/admin/ai-assistant/log/$userId/$conversationId'
      preLoaderRoute: typeof AdminAiAssistantLogUserIdConversationIdRouteImport
      parentRoute: typeof AdminAiAssistantLogRouteRoute
    }
  }
}

interface AdminAiAssistantLogRouteRouteChildren {
  AdminAiAssistantLogIndexRoute: typeof AdminAiAssistantLogIndexRoute
  AdminAiAssistantLogUserIdConversationIdRoute: typeof AdminAiAssistantLogUserIdConversationIdRoute
  AdminAiAssistantLogUserIdIndexRoute: typeof AdminAiAssistantLogUserIdIndexRoute
}

const AdminAiAssistantLogRouteRouteChildren: AdminAiAssistantLogRouteRouteChildren =
  {
    AdminAiAssistantLogIndexRoute: AdminAiAssistantLogIndexRoute,
    AdminAiAssistantLogUserIdConversationIdRoute:
      AdminAiAssistantLogUserIdConversationIdRoute,
    AdminAiAssistantLogUserIdIndexRoute: AdminAiAssistantLogUserIdIndexRoute,
  }

const AdminAiAssistantLogRouteRouteWithChildren =
  AdminAiAssistantLogRouteRoute._addFileChildren(
    AdminAiAssistantLogRouteRouteChildren,
  )

interface AdminAiAssistantRouteRouteChildren {
  AdminAiAssistantLogRouteRoute: typeof AdminAiAssistantLogRouteRouteWithChildren
  AdminAiAssistantPemakaianRoute: typeof AdminAiAssistantPemakaianRoute
  AdminAiAssistantPenyediaRoute: typeof AdminAiAssistantPenyediaRoute
  AdminAiAssistantPersonaRoute: typeof AdminAiAssistantPersonaRoute
  AdminAiAssistantUmumRoute: typeof AdminAiAssistantUmumRoute
  AdminAiAssistantIndexRoute: typeof AdminAiAssistantIndexRoute
}

const AdminAiAssistantRouteRouteChildren: AdminAiAssistantRouteRouteChildren = {
  AdminAiAssistantLogRouteRoute: AdminAiAssistantLogRouteRouteWithChildren,
  AdminAiAssistantPemakaianRoute: AdminAiAssistantPemakaianRoute,
  AdminAiAssistantPenyediaRoute: AdminAiAssistantPenyediaRoute,
  AdminAiAssistantPersonaRoute: AdminAiAssistantPersonaRoute,
  AdminAiAssistantUmumRoute: AdminAiAssistantUmumRoute,
  AdminAiAssistantIndexRoute: AdminAiAssistantIndexRoute,
}

const AdminAiAssistantRouteRouteWithChildren =
  AdminAiAssistantRouteRoute._addFileChildren(
    AdminAiAssistantRouteRouteChildren,
  )

interface AdminRouteRouteChildren {
  AdminAiAssistantRouteRoute: typeof AdminAiAssistantRouteRouteWithChildren
  AdminApikeyRoute: typeof AdminApikeyRoute
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminHelpRoute: typeof AdminHelpRoute
  AdminPreferencesRoute: typeof AdminPreferencesRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminServerLogRoute: typeof AdminServerLogRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSystemHealthRoute: typeof AdminSystemHealthRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAiAssistantRouteRoute: AdminAiAssistantRouteRouteWithChildren,
  AdminApikeyRoute: AdminApikeyRoute,
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminHelpRoute: AdminHelpRoute,
  AdminPreferencesRoute: AdminPreferencesRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminServerLogRoute: AdminServerLogRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSystemHealthRoute: AdminSystemHealthRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface PengaturanRouteRouteChildren {
  PengaturanAksesDanTimRoute: typeof PengaturanAksesDanTimRoute
  PengaturanKeamananRoute: typeof PengaturanKeamananRoute
  PengaturanNotifikasiRoute: typeof PengaturanNotifikasiRoute
  PengaturanSinkronisasiRoute: typeof PengaturanSinkronisasiRoute
  PengaturanUmumRoute: typeof PengaturanUmumRoute
}

const PengaturanRouteRouteChildren: PengaturanRouteRouteChildren = {
  PengaturanAksesDanTimRoute: PengaturanAksesDanTimRoute,
  PengaturanKeamananRoute: PengaturanKeamananRoute,
  PengaturanNotifikasiRoute: PengaturanNotifikasiRoute,
  PengaturanSinkronisasiRoute: PengaturanSinkronisasiRoute,
  PengaturanUmumRoute: PengaturanUmumRoute,
}

const PengaturanRouteRouteWithChildren = PengaturanRouteRoute._addFileChildren(
  PengaturanRouteRouteChildren,
)

interface ProfileRouteRouteChildren {
  ProfileEditRoute: typeof ProfileEditRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
}

const ProfileRouteRouteChildren: ProfileRouteRouteChildren = {
  ProfileEditRoute: ProfileEditRoute,
  ProfileIndexRoute: ProfileIndexRoute,
}

const ProfileRouteRouteWithChildren = ProfileRouteRoute._addFileChildren(
  ProfileRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  PengaturanRouteRoute: PengaturanRouteRouteWithChildren,
  ProfileRouteRoute: ProfileRouteRouteWithChildren,
  BantuanRoute: BantuanRoute,
  BumdesRoute: BumdesRoute,
  DemografiPekerjaanRoute: DemografiPekerjaanRoute,
  JennaAnalyticRoute: JennaAnalyticRoute,
  KeamananRoute: KeamananRoute,
  KeuanganAnggaranRoute: KeuanganAnggaranRoute,
  KinerjaDivisiRoute: KinerjaDivisiRoute,
  PengaduanLayananPublikRoute: PengaduanLayananPublikRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  SosialRoute: SosialRoute,
  WallRoute: WallRoute,
  UsersIdRoute: UsersIdRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
